import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting,
  defaultSizeSetting,
  defaultColorSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
import { type } from "jquery"
export const props = [
  {
    name: "btnSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      widthVal: 80,
      widthAuto: true,
      widthFull: false,
      heightVal: 35,
      heightAuto: true
    },
    extraConfig: {
      noFull: true
    }
  },
  {
    name: "btnText",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "btnTextHover",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "btnTextActive",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: 'btnIcon',
    desc: '图标',
    type: 'iconSet',
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: 'btnIconActive',
    desc: '图标',
    type: 'iconSet',
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: "btnBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "btnBackgroundActive",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "btnBackgroundHover",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "showBtnBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "showBtnBorderHover",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "showBtnBorderActive",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "btnBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnBorderHover",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnBorderActive",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "btnRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "btnRadiusHover",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "btnRadiusActive",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "btnPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: defaultPaddingSetting
  },
  {
    name: "btnOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "btnShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "activeIsSameWithHover",
    desc: "同选中状态",
    type: "booleanSet",
    defaultValue: true
  }
]

export const menuSetting = [
  {
    type: "status",
    statusSettings: [
      {
        title: "默认",
        settings: [
          {
            type: "collapse",
            title: "尺寸",
            settings: ["btnSize"]
          },
          {
            type: "collapse",
            title: "文字",
            settings: ["btnText"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["btnBackground"]
          },
          {
            type: "collapse",
            title: "图标",
            initStatus: 'closed',
            settings: ["btnIcon"]
          },
          {
            type: "collapse",
            title: "边框",
            initStatus: 'closed',
            settings: [
              {
                type: "basic",
                name: "btnBorder",
              },
              "btnRadius"
            ]
          },
          {
            type: "collapse",
            title: "边距",
            initStatus: 'closed',
            settings: ["btnPadding"]
          },
          {
            type: "collapse",
            title: "更多",
            initStatus: 'closed',
            settings: ["btnOpacity", "btnShadow"]
          }
        ]
      },
      {
        title: "选中",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: ["btnTextActive"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["btnBackgroundActive"]
          },
          {
            type: "collapse",
            title: "图标",
            initStatus: 'closed',
            settings: ["btnIconActive"]
          },
          {
            type: "collapse",
            title: "边框",
            initStatus: 'closed',
            settings: [{type: "basic", name: "btnBorderActive"}, "btnRadiusActive"]
          }
        ]
      },
      {
        title: "悬停",
        settings: [
          'activeIsSameWithHover',
          {
            type: 'collection',
            enable(config) {
              return !config.activeIsSameWithHover
            },
            settings: [
              {
                type: "collapse",
                title: "文字",
                settings: ["btnTextHover"]
              },
              {
                type: "collapse",
                title: "背景",
                settings: ["btnBackgroundHover"]
              },
              {
                type: "collapse",
                title: "边框",
                initStatus: 'closed',
                settings: [{type: "basic", name: "btnBorderHover"}, "btnRadiusHover"]
              }
            ]
          }   
        ]
      }
    ]
  }
]
